import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserNamePipeModule } from '@wilson/account';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { QualificationNamePipe } from '@wilson/qualification-v2/common';
import { UserQualificationsV2ListService } from '../../../../../service/user-qualifications-v2-list.service';

@Component({
  selector: 'wilson-bulk-edit-qualifications-selection-list',
  imports: [
    CommonModule,
    NzCollapseModule,
    TranslatePipe,
    UserNamePipeModule,
    QualificationNamePipe,
  ],
  templateUrl: './bulk-edit-qualifications-selection-list.component.html',
  styleUrl: './bulk-edit-qualifications-selection-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkEditQualificationsSelectionListComponent {
  private readonly userQualificationsV2ListService = inject(
    UserQualificationsV2ListService,
  );

  protected bulkEditSelection$ =
    this.userQualificationsV2ListService.selectedQualifications$;
}
